/* Simply Murals — mural.js
   Wall size calculator: product price is treated as price per m².
   Width x height (cm) -> area -> quantity (whole m², rounded up),
   dimensions stored as line item properties. */
(function () {
  'use strict';

  function money(cents) {
    var format = (window.themeSettings && window.themeSettings.moneyFormat) || '£{{amount}}';
    var value = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  document.querySelectorAll('[data-wall-calculator]').forEach(function (calc) {
    var wrapper = calc.closest('[data-product-wrapper]');
    var form = wrapper && wrapper.querySelector('form[data-product-form]');
    if (!form) return;

    var widthInput = calc.querySelector('[data-wall-width]');
    var heightInput = calc.querySelector('[data-wall-height]');
    var areaOut = calc.querySelector('[data-wall-area]');
    var totalOut = calc.querySelector('[data-wall-total]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var minArea = parseInt(calc.getAttribute('data-min-area'), 10) || 1;

    // hidden line item properties
    var propWidth = form.querySelector('input[name="properties[Wall width (cm)]"]');
    var propHeight = form.querySelector('input[name="properties[Wall height (cm)]"]');

    function unitPrice() {
      var idInput = form.querySelector('input[name="id"]');
      var jsonEl = wrapper.querySelector('[data-product-json]');
      if (!jsonEl) return 0;
      try {
        var product = JSON.parse(jsonEl.textContent);
        var id = idInput ? parseInt(idInput.value, 10) : null;
        var variant = product.variants.find(function (v) { return v.id === id; }) || product.variants[0];
        return variant ? variant.price : 0;
      } catch (e) { return 0; }
    }

    function update() {
      var w = parseFloat(widthInput.value);
      var h = parseFloat(heightInput.value);
      var valid = w > 0 && h > 0;
      if (!valid) {
        if (areaOut) areaOut.textContent = '—';
        if (totalOut) totalOut.textContent = '—';
        if (addBtn) addBtn.disabled = true;
        return;
      }
      var exact = (w / 100) * (h / 100);
      var billable = Math.max(minArea, Math.ceil(exact));
      if (areaOut) areaOut.textContent = exact.toFixed(2) + ' m² (billed as ' + billable + ' m²)';
      if (totalOut) totalOut.textContent = money(unitPrice() * billable);
      if (qtyInput) qtyInput.value = billable;
      if (propWidth) propWidth.value = w;
      if (propHeight) propHeight.value = h;
      if (addBtn) addBtn.disabled = false;
    }

    [widthInput, heightInput].forEach(function (el) {
      if (el) {
        el.addEventListener('input', update);
        el.addEventListener('change', update);
      }
    });
    // recalc when the variant (material) changes
    wrapper.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) setTimeout(update, 50);
    });
    update();
  });

  /* ---------- order a sample ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sample-add]');
    if (!btn) return;
    e.preventDefault();
    var variantId = parseInt(btn.getAttribute('data-sample-add'), 10);
    if (!variantId) return;
    var designTitle = btn.getAttribute('data-sample-design') || '';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: designTitle ? { 'Sample of': designTitle } : undefined
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('hidden', cart.item_count === 0);
        });
        return fetch(window.location.pathname + '?sections=cart-drawer');
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        var current = document.getElementById('CartDrawer');
        if (html && current) {
          var temp = document.createElement('div');
          temp.innerHTML = html;
          var fresh = temp.querySelector('#CartDrawer');
          if (fresh) current.innerHTML = fresh.innerHTML;
          current.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
      })
      .catch(function () {})
      .finally(function () { btn.disabled = false; });
  });
})();
